import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { fetchStakeholdersForTopicFailure, fetchStakeholdersForTopicSuccess } from "entities/stakeholders/actions";
import type { StakeholdersFetchForTopicAction } from "entities/stakeholders/actionTypes";
import type { Stakeholder } from "entities/stakeholders/types";

export function* fetchStakeholdersForTopicSaga(action: StakeholdersFetchForTopicAction) {
  const { id, offset, limit, search, type, role } = action.payload;
  try {
    const payload: Stakeholder[] = yield apiFetch(`topic/${id}/stakeholder`, {
      queryParams: {
        offset,
        limit,
        full_name: search,
        type,
        role,
        approved: "true",
      },
    });

    yield put(fetchStakeholdersForTopicSuccess({ data: payload }, action.payload));
  } catch {
    yield put(fetchStakeholdersForTopicFailure({ logoutOnAuthError: true, searchCriteria: action.payload }));
  }
}
